/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-new, no-prototype-builtins, import/no-amd */
/* global $ */

import * as d3 from 'd3'

const nullishValues = new Set([null, undefined])

function setTextColorWithBackground(color) {
    const { r } = color
    const { g } = color
    const { b } = color
    const colorValue = Math.round(
        (parseInt(r, 10) * 299 +
            parseInt(g, 10) * 587 +
            parseInt(b, 10) * 114) /
            1000
    )

    return colorValue > 125 ? '#000' : '#fff'
}

function MakeTable(opts) {
    function Table(tableOpts) {
        this.highlightColor = d3.scaleLinear()

        this.highlightRanking = d3
            .scaleLinear()
            .range(['#ff7777', '#ffffff'])
            .domain([1, 20])

        // Sets global tableOpts variables
        this.initOpts(tableOpts)
        // Initiliazes table and draws it
        this.initTable()
    }

    Table.prototype.initTable = function initTable() {
        // this.tableHeader = '<table><thead>';
        this.secondaryHeaderHTML = ''
        this.primaryHeaderHTML = ''
        if (this.secondaryHeaders) {
            this.secondaryHeaderHTML = this.secondaryHeader(
                this.secondaryHeaders
            )
        }
        this.primaryHeaderHTML = this.primaryHeader(this.headers, 'th')
        this.tableFooter = ''
        // this.tableHeader += '</thead><tbody>'
        this.tableClose = '</tbody></table>'
        this.showFooterLinks = false
        this.currentSortColumn = []

        // If dynamically highlighted columns exist, identify it/them
        // First if check filters out "League" tables that don't get highlighted
        if (this.data.length > 1) {
            this.dynamicHighlightHeaders = this.headers
                .filter((d) => d.highlightDynamic)
                .map((h) => h.field)

            if (this.dynamicHighlightHeaders.length) {
                this.hasDynamicHighlights = true
                this.dynamicHighlightDomains = getDynamicDomains(
                    this.dynamicHighlightHeaders,
                    this.data
                )
            }
        }

        // If defaultSort column passed in and it exists sort by that column initially
        if (this.defaultSort) {
            this.currentSortColumn = this.defaultSort

            this.sortColumns()
        }

        if (this.data) {
            this.populateRow(this.data)
        }
    }

    // Sort by (potentially) multiple columns
    Table.prototype.sortColumns = function sortColumns() {
        const reversedSorts = this.currentSortColumn.slice().reverse()

        reversedSorts.forEach(({ field, state }) => {
            const header = this.headers.find(
                (d) => field === d.customSortField || field === d.field
            )

            if (header) {
                header.state = state

                this.handlePreSort(header)

                this.sortColumn(header)
            }
        })
    }

    // Set opts variables
    Table.prototype.initOpts = function initOptsFn(initOpts) {
        if (initOpts.id) {
            this.id = initOpts.id
            this.sel = $(`#${initOpts.id}`)
        }
        if (initOpts.data) {
            this.data = initOpts.data
        }
        if (initOpts.headers) {
            this.headers = initOpts.headers
        }
        if (initOpts.secondaryHeaders) {
            this.secondaryHeaders = initOpts.secondaryHeaders
        }
        if (initOpts.defaultSort) {
            if (typeof initOpts.defaultSort === 'string') {
                const header = this.headers.find(
                    (d) =>
                        initOpts.defaultSort === d.customSortField ||
                        initOpts.defaultSort === d.field
                )

                // This is done to match the way it currently works, I think.
                const state =
                    initOpts.initialSortDirection ||
                    initOpts.defaultSortDirection ||
                    header.defaultSortDir ||
                    'desc'

                // eslint-disable-next-line no-param-reassign
                initOpts.defaultSort = [{ field: initOpts.defaultSort, state }]
            }
            this.defaultSort = initOpts.defaultSort
            this.currentSortColumn = initOpts.defaultSort
        }
        if (initOpts.defaultSortDirection) {
            this.defaultSortDirection = initOpts.defaultSortDirection
        } else {
            this.defaultSortDirection = 'desc'
        }

        if (initOpts.initialSortDirection) {
            this.initialSortDirection = initOpts.initialSortDirection
        }
        if (initOpts.subDataId) {
            this.subDataId = initOpts.subDataId
        }
        if (initOpts.drawerAvailable) {
            this.drawerAvailable = initOpts.drawerAvailable
        }
        if (initOpts.uniqueId) {
            this.uniqueId = initOpts.uniqueId
        }
        if (initOpts.showRank) {
            this.showRank = initOpts.showRank
        }
        if (initOpts.repeatHeader) {
            this.repeatHeader = initOpts.repeatHeader
        }

        this.hasPinned = Boolean(initOpts.hasPinned)

        if (initOpts.isSticky) {
            this.isSticky = initOpts.isSticky
        }

        if (initOpts.filter) {
            this.filter = initOpts.filter
        }
        if (initOpts.footer) {
            this.footer = initOpts.footer
        }
        if (initOpts.sortClass) {
            this.sortClass = initOpts.sortClass
        }
        if (opts.footerClass) {
            this.footerClass = opts.footerClass
        }
        if (initOpts.sortCallback) {
            this.sortCallback = initOpts.sortCallback
        }

        if (initOpts.rowClass) {
            this.rowClass = initOpts.rowClass
        }

        this.highlightValFn = initOpts.highlightValFn || ((val) => val)

        // default is true, make true unless explicit
        this.highlightFalsy = initOpts.highlightFalsy !== false
        this.highlightNullish = initOpts.highlightNullish !== false

        this.existsLinkedSort =
            this.headers.filter((header) => header.isLinkedSort).length > 0
    }

    // Draw table and attach event listeners
    Table.prototype.drawTable = function drawTable() {
        this.sel.html('')
        if (this.footer) {
            this.populateRow(this.footer, true)
        }
        this.sel.html(
            `<table><thead>${this.secondaryHeaderHTML}${this.primaryHeaderHTML}</thead><tbody>${this.tableRows}${this.tableFooter}${this.tableClose}`
        )
        this.addListeners()
    }

    // Add event listeners for sorting
    Table.prototype.addListeners = function addListeners() {
        const This = this

        try {
            for (let x = 0; x < this.headers.length; x++) {
                /* document.getElementById(This.id + "_th-" + x).addEventListener("mouseover", function () {
                        console.log('over');
                        var id = this.id.split('-')[1];
                        document.getElementById('tooltip-' + This.id + "_th-" + id).style.display = 'block';

                    });
                    document.getElementById(This.id + "_th-" + x).addEventListener("mouseleave", function () {
                        console.log('leave');
                        var id = this.id.split('-')[1];
                        document.getElementById('tooltip-' + This.id + "_th-" + id).style.display = 'none';
                    }); */

                const th = document.getElementById(`${This.id}_th-${x}`)

                // This prevents the browser default to select text when holding the shift key.
                th.addEventListener(
                    'mousedown',
                    (e) => e.shiftKey && e.preventDefault()
                )

                th.addEventListener('click', function clickHandler(e) {
                    e.preventDefault()
                    const isSecondary = e.shiftKey

                    const id = this.id.split('-')[1]
                    const header = This.headers[id]

                    // Make sure it's explicitly set to false
                    if (header.sortable === false) {
                        return
                    }

                    const lastIdx = This.currentSortColumn.length - 1
                    const relevantSort =
                        This.currentSortColumn[isSecondary ? lastIdx : 0]

                    const sortColumn = header.customSortField || header.field
                    const isFlip =
                        Boolean(relevantSort) &&
                        (sortColumn === relevantSort.field ||
                            sortColumn === relevantSort.customSortField)

                    // If it's already set, flip it
                    if (isFlip) {
                        This.headers[id].state =
                            header.state === 'asc' ? 'desc' : 'asc'
                    } else {
                        This.headers[id].state =
                            header.defaultSortDir || This.defaultSortDirection
                    }

                    const newSort = {
                        field: sortColumn,
                        state: This.headers[id].state,
                    }

                    if (isSecondary) {
                        // tack on the end
                        This.currentSortColumn = [
                            ...This.currentSortColumn.filter(
                                (d) => d.field !== newSort.field
                            ),
                            newSort,
                        ]
                    } else {
                        This.currentSortColumn = [newSort]
                    }

                    This.sortColumns()

                    // This.tableHeader = '';
                    This.primaryHeaderHTML = This.primaryHeader(
                        This.headers,
                        'th'
                    )
                    This.populateRow(This.data)

                    if (This.sortCallback) {
                        This.sortCallback(
                            This.currentSortColumn[0].field,
                            id,
                            This.headers[id],
                            This.data,
                            This
                        )
                    }
                })
            }
        } catch (ex) {
                console.log('Error: Maybe mismatched opts.id???') // eslint-disable-line
                console.error(ex) // eslint-disable-line
            throw ex
        }
    }

    // headers closest to start of TR
    Table.prototype.primaryHeader = function primaryHeader(headers, type) {
        const This = this
        let html = '<tr class="tr-component-row">'
        if (this.showRank) {
            html += `<${type} class="th-component-rank th-component-header align-left th-vertical-bottom">Rk.${
                this.isSticky ? '<div>Rk.</div>' : ''
            }</${type}>`
        }

        for (let x = 0; x < headers.length; x++) {
            const header = headers[x]
            let cssClass = ''
            if (header.headerClass) {
                cssClass = ` class="${header.headerClass} ${
                    header.toolTip ? 'tooltip-hover' : ''
                }`

                if (header.sortable === false) {
                    cssClass += ` th-component-header-no-sort `
                }
            }

            if (
                this.sortClass &&
                (this.currentSortColumn[0].field === header.field ||
                    this.currentSortColumn[0].field === header.customSortField)
            ) {
                if (cssClass.indexOf('class=') > -1) {
                    cssClass += ` ${this.sortClass}`
                } else {
                    cssClass = ` class="${this.sortClass} ${
                        header.toolTip ? 'tooltip-hover' : ''
                    }`
                }
            }
            if (cssClass) {
                cssClass += '"'
            }

            let toolTip = ''
            if (header.toolTip) {
                toolTip = `<div class="${
                    header.toolTipClass || 'th-tooltip'
                }">${header.toolTip}</div>`
            }

            html += `<${type} id="${This.id}_th-${x}" ${cssClass}>${
                header.name
            }${
                this.isSticky ? `<div>${header.name}</div>` : ''
            }${toolTip}</${type}>`
        }
        html += '</tr>'
        return html
    }

    // Very Top Headers
    Table.prototype.secondaryHeader = function secondaryHeader(headers) {
        let html = '<tr>'
        for (let x = 0; x < headers.length; x++) {
            const header = headers[x]
            let cssClass = ''
            if (header.headerClass) {
                cssClass = ` class="${header.headerClass}" `
            }
            let colspan = 1

            if (header.colspan) {
                colspan = header.colspan
            }
            html += `<th colspan="${colspan}" ${cssClass}>${header.name}</th>`
        }
        html += '</tr>'
        return html
    }

    Table.prototype.populateRow = function populateRow(data, isFooter) {
        const This = this
        let tableHTML = ''
        let pinnedRows = 0
        for (let x = 0; x < data.length; x++) {
            if (this.repeatHeader && x % this.repeatHeader === 0 && x > 0) {
                tableHTML += this.primaryHeader(this.headers, 'th')
            }

            if (data[x]) {
                const pinnedRow = this.hasPinned && data[x].pinned

                if (pinnedRow) {
                    pinnedRows += 1
                }

                let rowId = x
                let rowStyle = ''
                // Used for AJAX Calls
                if (this.subDataId) {
                    rowId = data[x][this.subDataId]

                    if (
                        !this.drawerAvailable ||
                        this.drawerAvailable(data[x])
                    ) {
                        rowStyle = ' style="cursor: pointer;" '
                    }
                }
                // Used to inline change table rows (ie, coloring of barrels and low HP%)
                else if (this.uniqueId && data[x]) {
                    rowId = data[x][this.uniqueId]
                }

                // Append custom class per row if specified in the data set
                let customClass = ''
                if (data[x].customClass) {
                    customClass = data[x].customClass
                }

                // Append Footer Class if specified
                let footerClass = ''
                if (isFooter && this.footerClass) {
                    footerClass = this.footerClass
                }

                let rowClass = this.rowClass || ''

                rowClass = pinnedRow
                    ? (rowClass += ' savant-table-pinned-row')
                    : rowClass

                tableHTML += `<tr id="${This.id}-tr_${rowId}" class="default-table-row ${rowClass} ${footerClass} ${customClass}" ${rowStyle} data-id="${rowId}">`

                if (this.showRank) {
                    const rank = pinnedRow ? '' : x + 1 - pinnedRows
                    tableHTML += `<td>${rank}</td>`
                }
                for (let y = 0; y < this.headers.length; y++) {
                    const header = this.headers[y]

                    let cssClass = ''
                    if (header.fieldClass) {
                        cssClass = ` class="${header.fieldClass} `
                    }
                    if (
                        this.sortClass &&
                        (this.currentSortColumn[0].field === header.field ||
                            this.currentSortColumn[0].field ===
                                header.customSortField) &&
                        !isFooter
                    ) {
                        if (cssClass.indexOf('class=') > -1) {
                            cssClass += ` ${this.sortClass}`
                        } else {
                            cssClass = ` class="${this.sortClass} `
                        }
                    }
                    if (header.footerClass && isFooter) {
                        if (cssClass.indexOf('class=') > -1) {
                            cssClass += ` ${header.footerClass}`
                        } else {
                            cssClass = ` class="${this.sortClass} `
                        }
                    }

                    if (cssClass) {
                        cssClass += '"'
                    }

                    let id = ''
                    // Only allow id to be used on td if it has a uniqueId defined
                    if (header.id && this.uniqueId) {
                        id = ` id="td_${data[x][this.uniqueId]}_${header.id}" `
                    }

                    let fieldData = ''

                    if (data[x].hasOwnProperty(header.field)) {
                        fieldData = data[x][header.field]
                    }

                    if (fieldData == null || header.photoOnly === true) {
                        fieldData = ''
                    }

                    if (
                        header.fieldAlt &&
                        typeof header.fieldAlt === 'string'
                    ) {
                        cssClass += ` title="${header.fieldAlt}" `
                    } else if (
                        header.fieldAlt &&
                        typeof header.fieldAlt === 'function'
                    ) {
                        const title = header.fieldAlt(
                            fieldData,
                            data[x],
                            header
                        )
                        cssClass += ` title="${title}" `
                    }

                    let rankingData = ''

                    if (data[x].hasOwnProperty(header.ranking)) {
                        rankingData = data[x][header.ranking]
                    }

                    let photo = ''
                    if (header.photo) {
                        photo = header.photo
                            .split('{1}')
                            .join(data[x][header.photoId])
                    }

                    let background = ''
                    let backgroundColor = ''
                    if (
                        header.highlightDynamic ||
                        (header.highlight && header.highlight.length > 0)
                    ) {
                        if (header.highlight && header.highlight.length === 5) {
                            this.highlightColor = d3
                                .scaleLinear()
                                .clamp(true)
                                .range(
                                    header.highlightColors || [
                                        '#3661AD',
                                        '#3661AD',
                                        '#ffffff',
                                        '#D82129',
                                        '#D82129',
                                    ]
                                )
                        } else if (
                            header.highlightDynamic &&
                            !this.hasDynamicHighlights
                        ) {
                            // Specific case to handle the "league" default gray highlight for a one-row table
                            this.highlightColor = d3
                                .scaleLinear()
                                .clamp(true)
                                .range(['#DCDCDC', '#DCDCDC', '#DCDCDC'])
                        } else {
                            this.highlightColor = d3
                                .scaleLinear()
                                .clamp(true)
                                .range(
                                    header.highlightColors || [
                                        '#3661AD',
                                        '#ffffff',
                                        '#D82129',
                                    ]
                                )
                        }

                        if (
                            header.highlightDynamic &&
                            this.hasDynamicHighlights
                        ) {
                            const highlightDomain =
                                this.dynamicHighlightDomains.find(
                                    (d) => d.field === header.field
                                ).domain

                            this.highlightColor.domain(highlightDomain)
                        } else if (header.highlight) {
                            this.highlightColor.domain(header.highlight)
                        }

                        let rankColumn = fieldData
                        if (data[x].hasOwnProperty(header.rankColumn)) {
                            rankColumn = data[x][header.rankColumn]
                        }

                        if (
                            this.highlightNullish === false &&
                            !nullishValues.has(rankColumn)
                        ) {
                            const val = this.highlightValFn(
                                rankColumn,
                                data[x],
                                data
                            )
                            backgroundColor = this.highlightColor(val)
                            background = `style="background-color: ${backgroundColor}" `
                        } else if (
                            (this.highlightFalsy === false && rankColumn) ||
                            (this.highlightFalsy !== false &&
                                this.highlightNullish !== false)
                        ) {
                            const val = this.highlightValFn(
                                rankColumn,
                                data[x],
                                data
                            )
                            backgroundColor = this.highlightColor(val)
                            background = `style="background-color: ${backgroundColor}" `
                        }
                    }

                    const spanFieldData = this.getSpan(
                        header,
                        data[x],
                        rankingData,
                        fieldData,
                        isFooter,
                        backgroundColor
                    )

                    tableHTML += `<td ${id} ${cssClass} ${background}>${photo} ${spanFieldData}</td>`
                }
                tableHTML += '</tr>'

                if (this.subDataId) {
                    tableHTML += `<tr class="tr-sub-data" id="${
                        This.id
                    }-trSub_${rowId}" style="background-color: #ffffff; display: none;"><td id="${
                        This.id
                    }-tdSub_${rowId}" colspan="${
                        this.headers.length + (This.showRank ? 1 : 0)
                    }" ></td></tr>`
                    // To keep stripe add another row
                    tableHTML += '<tr style="display: none;"></tr>'
                }
            }
        }
        if (!isFooter) {
            this.tableRows = tableHTML
            this.drawTable()
        } else {
            this.tableFooter = tableHTML
        }
    }

    // Returns table span
    Table.prototype.getSpan = function getSpan(
        header,
        data,
        rankingData,
        fieldData,
        isFooter,
        backgroundColor
    ) {
        let spanStart = '<span'
        const spanEnd = '</span>'

        if (header.spanClass) {
            if (data.playerId && data.season) {
                spanStart += ` id="${
                    Array.isArray(header.spanClass)
                        ? header.spanClass.map((d) => d.className).join(' ')
                        : header.spanClass
                }_${data.playerId}_${data.season}" `
            }

            if (
                header.spanClass.length &&
                header.spanClass.length > 0 &&
                Array.isArray(header.spanClass)
            ) {
                spanStart += ' class="'

                for (let x = 0; x < header.spanClass.length; x++) {
                    const c = header.spanClass[x]
                    if (c.className && c.exception && !isFooter) {
                        if (
                            c.exception === 'gte' &&
                            data[c.field] >= c.parameter
                        ) {
                            this.showFooterLinks = true
                            spanStart += ` ${c.className}`
                        } else if (
                            c.exception === 'gt' &&
                            data[c.field] > c.parameter
                        ) {
                            this.showFooterLinks = true
                            spanStart += ` ${c.className}`
                        } else if (
                            c.exception === 'lte' &&
                            data[c.field] <= c.parameter
                        ) {
                            this.showFooterLinks = true
                            spanStart += ` ${c.className}`
                        } else if (
                            c.exception === 'lt' &&
                            data[c.field] < c.parameter
                        ) {
                            this.showFooterLinks = true
                            spanStart += ` ${c.className}`
                        } else if (
                            c.exception === 'eq' &&
                            data[c.field] === c.parameter
                        ) {
                            this.showFooterLinks = true
                            spanStart += ` ${c.className}`
                        }
                    } else if (
                        isFooter &&
                        c.includeFooter &&
                        this.showFooterLinks
                    ) {
                        spanStart += ` ${c.className}`
                    } else if (c.className && !c.exception) {
                        spanStart += ` ${c.className}`
                    }
                }
                spanStart += '"'
            } else {
                spanStart += ` class="${header.spanClass}" `
            }
        }
        if (header.ranking && rankingData) {
            spanStart += ` ${spanStart} style="padding: 0px 5px 0px 5px; background-color: ${this.highlightRanking(
                rankingData
            )};" `
        } else if (backgroundColor) {
            spanStart +=
                ` ` +
                ` style="color: ${setTextColorWithBackground(
                    d3.color(backgroundColor)
                )};" `
        }

        spanStart += '>'

        const value = header.displayFn
            ? header.displayFn(fieldData, data, header, isFooter)
            : fieldData
        return spanStart + value + spanEnd
    }

    Table.prototype.handlePreSort = function handlePreSort(header) {
        if (header.hasLinkedSort && this.existsLinkedSort) {
            const linkedHeader = this.headers.find(
                (h) => h.field === header.linkedSort
            )

            if (!linkedHeader) {
                throw new Error(`no linked header: ${header.linkedSort} found.`)
            }

            // Assume we want the same direction for sanity for now
            linkedHeader.state = header.state

            this.sortColumn(linkedHeader)
        }
    }

    // Sort by a single column
    Table.prototype.sortColumn = function sortColumn(header) {
        const { type, state, customSortField, field } = header
        const col = customSortField || field
        const isDesc = state === 'desc'

        this.data = this.data.sort((a, b) => {
            let aVal = sortFunction(type, a, col, this.hasPinned, isDesc)
            let bVal = sortFunction(type, b, col, this.hasPinned, isDesc)

            // `sortFunction` will return a maximum/minimum value for pinned rows, to place them at the top.
            // Without the following code those rows will all be tied and won't change order when sorted.
            // Below we check whether we are dealing with two pinned rows and if so set `false` for the `hasPinned` parameter.
            // This will allow the two pinned rows to be compared via the normal `sortFunction` value.
            if (a.pinned && b.pinned && this.hasPinned) {
                aVal = sortFunction(type, a, col, false, isDesc)
                bVal = sortFunction(type, b, col, false, isDesc)
            }

            if (aVal === bVal) {
                return 0
            }

            if (isDesc) {
                return aVal > bVal ? -1 : 1
            }

            return aVal > bVal ? 1 : -1
        })
    }

    Table.prototype.getHeader = function getHeader(headerName) {
        const header = this.headers.find(
            (d) => headerName === d.customSortField || headerName === d.field
        )

        return header
    }

    // Assume we have sorted already,
    Table.prototype.refreshTable = function refreshTable() {
        this.sortColumns()
        this.primaryHeaderHTML = this.primaryHeader(this.headers, 'th')
        this.populateRow(this.data)
    }

    return new Table(opts)
}

// Need to be lowercase for comparison sake...I think.
const almostMaxString = 'zzzzzzzzzzzzzzzzzzzzzzzzzzzz'
const maxestString = `${almostMaxString}z`

function sortFunction(type, row, sortColumn, hasPinned, isDesc = false) {
    let value
    if (row) {
        if (hasPinned && row.pinned && type === 'number') {
            return isDesc ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER
        }

        if (hasPinned && row.pinned) {
            return isDesc ? maxestString : ''
        }

        if (type === 'number') {
            value = row[sortColumn]

            // sort nulls last, picked random large number
            if (value === null || value === undefined) {
                value = isDesc
                    ? Number.MIN_SAFE_INTEGER + 1
                    : Number.MAX_SAFE_INTEGER - 1
            }

            return Number(String(value).replace('%', '').replace(',', ''))
        }

        if (!row[sortColumn]) {
            // Lowest unicode character vs. a slightly smaller string
            return isDesc ? '\u0000' : almostMaxString
        }

        return String(row[sortColumn]).toLowerCase()
    }

    return isDesc ? Number.MAX_SAFE_INTEGER - 1 : Number.MIN_SAFE_INTEGER + 1
}

function getDynamicDomains(headers, data) {
    return headers.map((h) => {
        const [min, max] = d3.extent(data, (d) => Number(d[h]))
        let valRange = []

        // A somewhat rough way to handle this, but we'll see how it looks
        if (min * max > 0) {
            const mid = (min + max) / 2
            const diff = 0.8 * (mid - min)
            valRange = [mid - diff, mid, mid + diff]
        } else {
            const extreme =
                Math.abs(min) > Math.abs(max) ? Math.abs(min) : Math.abs(max)
            valRange = [-0.8 * extreme, 0, 0.8 * extreme]
        }

        return { field: h, domain: valRange }
    })
}

export default MakeTable
